<template>
  <div class="projetocadastro">
    <div class="container">
      <ol class="breadcrumb-arrow">
        <li>
          <a href="/home"><i class="fa fa-home"></i></a>
          <a href="/projeto-listagem">Projetos</a>
        </li>
        <li>
          <a href="#">{{ title }}</a>
        </li>
      </ol>
    </div>

    <div class="container mt-2">
      <div class="card">
        <ProjetoFormulario
          :idprojeto="idprojeto"
          @cancel="voltar()"
          @save="salvarERedirecionar()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProjetoFormulario from "../components/ProjetoFormulario.vue";

export default {
  props: {
    idprojeto: {
      type: String,
      default: null,
    },
  },
  components: {
    ProjetoFormulario,
  },
  data() {
    return {
      title: this.idprojeto ? "Alterar" : "Incluir",
    };
  },
  methods: {
    voltar() {
      location.href = "/projeto-listagem";
    },
    salvarERedirecionar() {
      setTimeout(() => {
        location.href = "/projeto-listagem";
      }, 2000);
    },
  },
};
</script>

